export const COLUMN_WIDTHS = {
    name: '35%',
    productKey: '25%',
    locale: '15%',
    modifiedDate: '25%',
} as const;

export const COLUMN_HEADERS = {
    name: 'Name',
    productKey: 'Product Key',
    locale: 'Locales',
    modifiedDate: 'Last Modified',
} as const;
